/**
 * Shared loan and real estate amount value lists for sliders/inputs.
 * Used by customer-features (formService, field requests, loan application, widget)
 * and website-features (calculators).
 */

export const requestedLoanAmountValues = [
  10000, 25000, 50000, 75000, 100000, 125000, 150000, 200000, 250000, 300000,
  350000, 400000, 450000, 500000, 600000, 700000, 800000, 900000, 1000000,
  1250000, 1500000, 1750000, 2000000, 2500000, 3000000, 4000000, 5000000,
  6000000, 7000000, 8000000, 9000000, 10000000, 15000000, 20000000, 25000000,
  30000000, 50000000, 100000000, 200000000,
];

export const requestedLoanAmountValuesDefault = [
  10000, 25000, 50000, 75000, 100000, 125000, 150000, 200000, 250000, 300000,
  350000, 400000, 450000, 500000, 600000, 700000, 800000, 900000, 1000000,
  1250000, 1500000, 1750000, 2000000, 2500000, 3000000, 5000000, 10000000,
  20000000,
];

export const requestedLoanAmountValuesLarge = [
  3 * 1000 * 1000,
  4 * 1000 * 1000,
  5 * 1000 * 1000,
  6 * 1000 * 1000,
  7 * 1000 * 1000,
  8 * 1000 * 1000,
  9 * 1000 * 1000,
  10 * 1000 * 1000,
  15 * 1000 * 1000,
  20 * 1000 * 1000,
  25 * 1000 * 1000,
  30 * 1000 * 1000,
  50 * 1000 * 1000,
  100 * 1000 * 1000,
  200 * 1000 * 1000,
];

export const requestedRealEstateLoanAmountValues = [
  0, 100000, 200000, 500000, 1000000, 1500000, 2000000, 2500000, 3000000,
  3500000, 4000000, 5000000, 6000000, 7000000, 8000000, 9000000, 10000000,
  15000000, 20000000, 25000000, 30000000, 35000000, 40000000, 50000000,
  60000000, 75000000, 100000000, 200000000,
];

export const requestedRealEstateLoanAmountValuesDefault = [
  0, 100000, 200000, 500000, 1000000, 1500000, 2000000, 2500000, 3000000,
  3500000, 4000000, 5000000, 6000000, 7000000, 8000000, 9000000, 10000000,
  20000000,
];

export const requestedRealEstateLoanAmountValuesLarge = [
  10 * 1000 * 1000,
  15 * 1000 * 1000,
  20 * 1000 * 1000,
  25 * 1000 * 1000,
  30 * 1000 * 1000,
  35 * 1000 * 1000,
  40 * 1000 * 1000,
  50 * 1000 * 1000,
  60 * 1000 * 1000,
  75 * 1000 * 1000,
  100 * 1000 * 1000,
  200 * 1000 * 1000,
];

/** Repayment time in months – used by loan and real estate calculators. */
export const calculatorRepaymentTimeValuesMonths = [
  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 24, 30, 36, 42, 48, 54, 60,
];

/** Repayment time in months – used by leasing calculator (extends base with 66–84). */
export const calculatorRepaymentTimeLeasingValuesMonths = [
  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78,
  84,
];

/** Interest rate percentage values – used by loan, leasing, and real estate calculators. */
export const calculatorInterestRateValues = [
  3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
];
